module.exports = __webpack_public_path__ + "static/media/Practitioners_appointment.6c1770bf.svg";